<template>
  <div class="order-page">
    <div v-show="!isH5" class="order-desktop" style="width: 100%;overflow: hidden">
      <el-main id="recharge-div-one">
        <div
          style="text-align: left;font-size: 14px;font-family: Noto Sans S Chinese;font-weight: 500;color: #333333;">
          <div class="order-section-header" style="width: 890px;height: 60px;">
            <div class="order-section-title">
              <span class="title-font" style="margin-left: 12px;
              font-size: 20px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #666666;">开票记录</span>
              <span v-if="isMockPreview" class="order-mock-badge">演示数据</span>
            </div>
          </div>
          <div class="order-table-section">
            <div class="order-table-scroll" role="region" aria-label="开票记录，可横向滚动" tabindex="0">
            <el-table
              class="order-table order-table--bills"
              ref="multipleTable"
              :data="tableDataBill"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange">
              <el-table-column
                prop="billCode"
                label="开票编号"
                width="180">
              </el-table-column>
              <el-table-column
                prop="productTitles"
                label="开票内容"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatProductTitles(scope.row.productTitles) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="createDateTimeStr"
                label="开票时间"
                width="160">
              </el-table-column>
              <el-table-column
                prop="turnover"
                label="发票金额"
                width="80"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="status"
                label="开票状态"
                width="100">
                <template slot-scope="scope">
                  <div>{{
                      scope.row.status === 1 ? '开票中' : scope.row.status === 2 ?
                        '开票完成' : scope.row.status === 3 ? '已下载' : '开票失败'
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <div v-show="scope.row.status === 2 || scope.row.status === 3" class="no-1"
                       data-track-text="下载发票" :data-track-business-id="scope.row.billCode"
                       @click="download(scope.row)">下载
                  </div>
                  <div v-show="scope.row.status !== 2 && scope.row.status !== 3" class="no2-1"
                       data-track-text="不可下载发票" :data-track-business-id="scope.row.billCode"
                       @click="()=>void(0)">下载
                  </div>
                </template>
              </el-table-column>
            </el-table>
            </div>
            <div class="order-mobile-list" aria-label="开票记录">
              <article v-for="item in tableDataBill" :key="item.billCode" class="order-card">
                <header class="order-card__header">
                  <div class="order-card__identity">
                    <span class="order-card__eyebrow">开票编号</span>
                    <strong class="order-card__number">{{ displayValue(item.billCode) }}</strong>
                  </div>
                  <span class="order-status" :class="billStatusClass(item.status)">
                    {{ billStatusText(item.status) }}
                  </span>
                </header>
                <div class="order-card__content">
                  <div class="order-card__field order-card__field--full">
                    <span>开票内容</span>
                    <strong>{{ formatProductTitles(item.productTitles) }}</strong>
                  </div>
                  <div class="order-card__field">
                    <span>开票时间</span>
                    <strong>{{ displayValue(item.createDateTimeStr) }}</strong>
                  </div>
                  <div class="order-card__field order-card__field--amount">
                    <span>发票金额</span>
                    <strong>¥{{ displayMoney(item.turnover) }}</strong>
                  </div>
                </div>
                <footer class="order-card__actions">
                  <button type="button" class="order-card__button order-card__button--ghost"
                          data-track-text="查看发票详情" :data-track-business-id="item.billCode"
                          @click="toPath('Billdetail', item)">查看详情</button>
                  <button type="button" class="order-card__button order-card__button--primary"
                          data-track-text="下载发票" :data-track-business-id="item.billCode"
                          :disabled="item.status !== 2 && item.status !== 3"
                          @click="download(item)">下载发票</button>
                </footer>
              </article>
              <div v-if="tableDataBill.length === 0" class="order-empty-state">
                <i class="el-icon-document"></i>
                <strong>暂无开票记录</strong>
                <span>申请后，可在这里查看进度并下载发票</span>
              </div>
            </div>
            <div class="order-pagination" style="width: 100%;display:flex;justify-content: flex-end;margin-top: 10px "
                 v-show="totalBill!==0">
              <el-pagination
                :page-size="5"
                @current-change="handleCurrentChangeBill"
                background
                layout="prev, pager, next"
                :total="totalBill">
              </el-pagination>
            </div>
          </div>
        </div>
      </el-main>
      <el-alert
        title="如有需要，可添加微思翻译在线服务QQ号码：1077258421，进行沟通。"
        type="warning">
      </el-alert>
      <el-main id="recharge-div">
        <div class="order-section-header order-history-header" style="width: 860px;height: 60px;display: flex;justify-content: space-between">
          <div class="order-section-title">
            <span class="title-font" style="margin-left: 12px;
            font-size: 20px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #666666;">历史订单</span>
            <span v-if="isMockPreview" class="order-mock-badge">演示数据</span>
          </div>
          <div class="order-selection-summary" style="display: flex;align-items: center;" v-show="multipleSelection.length>0">
            <div>合计金额:<span style="color: rgb(225, 63, 63);margin-left: 10px;margin-right: 5px;">¥</span>
              <span style="font-size: 30px;color:rgb(225, 63, 63);margin-right: 10px ">{{ totalMoney }}</span></div>
            <div class="no-he"
                 data-track-text="合并申请发票"
                 @click="handleOpenAll()">合并申请
            </div>
          </div>
        </div>
        <!-- 充值显示部分套餐选项 -->
        <div id="select-div">
          <div class="order-table-scroll" role="region" aria-label="历史订单，可横向滚动" tabindex="0">
          <el-table
            class="order-table order-table--history"
            header-row-class-name="head"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              prop="batchId"
              width="50"
              :selectable="selectable"
            >
            </el-table-column>
            <el-table-column
              prop="batchId"
              label="订单编号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="productTitle"
              label="订单信息"
              show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.productTitle }}
              </template>
            </el-table-column>
            <el-table-column
              prop="createDateTimeStr"
              label="下单时间"
              width="160">
            </el-table-column>
            <el-table-column
              prop="turnover"
              label="订单金额"
              width="80"
              show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="status"
              label="申请状态"
              width="100">
              <template slot-scope="scope">
                <div>{{ scope.row.status === undefined || scope.row.status === null ? '未申请' : '已申请' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <div v-show="scope.row.status === undefined || scope.row.status === null" class="no"
                     data-track-text="申请发票" :data-track-business-id="scope.row.batchId"
                     @click="handleOpen(scope.$index, scope.row)">申请发票
                </div>
                <div v-show="scope.row.status !== undefined && scope.row.status !== null" class="no2"
                     data-track-text="已申请发票" :data-track-business-id="scope.row.batchId"
                     @click="()=>void(0)">申请发票
                </div>
              </template>
            </el-table-column>
          </el-table>
          </div>
          <div class="order-mobile-list" aria-label="历史订单">
            <article v-for="(item, index) in tableData" :key="item.batchId" class="order-card order-card--history">
              <header class="order-card__header">
                <div class="order-card__selection" @click.stop>
                  <el-checkbox
                    data-track-text="选择订单"
                    :data-track-business-id="item.batchId"
                    :value="isOrderSelected(item)"
                    :disabled="!selectable(item)"
                    :aria-label="'选择订单 ' + displayValue(item.batchId)"
                    @change="toggleMobileOrder(item, $event)">
                  </el-checkbox>
                </div>
                <div class="order-card__identity">
                  <span class="order-card__eyebrow">订单编号</span>
                  <strong class="order-card__number">{{ displayValue(item.batchId) }}</strong>
                </div>
                <span class="order-status" :class="selectable(item) ? 'order-status--pending' : 'order-status--done'">
                  {{ selectable(item) ? '未申请' : '已申请' }}
                </span>
              </header>
              <div class="order-card__content">
                <div class="order-card__field order-card__field--full">
                  <span>订单信息</span>
                  <strong>{{ displayValue(item.productTitle) }}</strong>
                </div>
                <div class="order-card__field">
                  <span>下单时间</span>
                  <strong>{{ displayValue(item.createDateTimeStr) }}</strong>
                </div>
                <div class="order-card__field order-card__field--amount">
                  <span>订单金额</span>
                  <strong>¥{{ displayMoney(item.turnover) }}</strong>
                </div>
              </div>
              <footer class="order-card__actions">
                <button type="button" class="order-card__button order-card__button--ghost"
                        data-track-text="查看订单详情" :data-track-business-id="item.batchId"
                        @click="toPath('DDdetail', item)">查看详情</button>
                <button type="button" class="order-card__button order-card__button--primary"
                        data-track-text="申请发票" :data-track-business-id="item.batchId"
                        :disabled="!selectable(item)"
                        @click="handleOpen(index, item)">申请发票</button>
              </footer>
            </article>
            <div v-if="tableData.length === 0" class="order-empty-state">
              <i class="el-icon-tickets"></i>
              <strong>暂无历史订单</strong>
              <span>订单完成后会自动显示在这里</span>
            </div>
          </div>
          <div class="order-pagination" style="width: 100%;display:flex;justify-content: flex-end;margin-top: 10px "
               v-show="total!==0">
            <el-pagination
              :page-size="8"
              @current-change="handleCurrentChange"
              background
              layout="prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-main>
      <el-dialog width="546px" :visible.sync="dialogFormVisible">
        <div slot="title" style="border-bottom: 1px #DDDDDD solid;padding-bottom: 15px;">
          <div style="text-align: left;margin-left: 55px;">
          <span style="text-align:left;font-size: 18px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #333333;">发票抬头</span>
          </div>
        </div>
        <el-form :model="form" ref="updatePassForm" :rules="updatePassFormRules">
          <el-form-item label="单位名称：" :label-width="formLabelWidth" class="custome-label" prop="company">
            <el-input class="custome-input" v-model="form.company"></el-input>
          </el-form-item>
          <el-form-item label="单位税号：" :label-width="formLabelWidth" class="custome-label" prop="companyCode">
            <el-input class="custome-input" v-model="form.companyCode"></el-input>
          </el-form-item>
          <el-form-item label="开票内容：" :label-width="formLabelWidth" class="custome-label custome-label-radio"  prop="content">
            <el-radio v-model="form.content" label="TECH_SVC">信息技术服务*技术服务费</el-radio>
            <el-radio v-model="form.content" label="TRANS_SVC">信息技术服务*翻译服务费</el-radio>
            <el-radio v-model="form.content" label="AUDIT_SVC">信息技术服务*审校费</el-radio>
            <el-radio v-model="form.content" label="OTHER_SVC">如需其他，请添加QQ1077258421，进行沟通</el-radio>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="height: 65px;margin-top: -5px;">
          <div style="text-align: center;width: 100%;">
          <span class="submitUpadatePass" style="
              padding: 10px 45px;
              background: #063f95;
              border-radius: 2px;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #FFFFFF;" data-track-text="提交发票申请" @click="submit">申请发票</span></div>
        </div>
        <div><span
          style="color: #df2525;font-size: 14px;font-family: Noto Sans S Chinese !important;">{{ messages }}</span>
        </div>
      </el-dialog>
    </div>
    <div v-show="isH5" class="user-main">
      <div class="user-main-head legacy-root-header">
        <img data-track-text="返回首页" @click="clickHanler('/index')" style="margin-left: 28px" src="../assets/go-back.png" alt=""/>
        <div>订单详情</div>
      </div>
      <div v-if="isMockPreview" class="order-h5-preview-note">
        <span class="order-mock-badge">演示数据</span>
        <span>仅用于查看有数据时的列表样式</span>
      </div>
      <div class="user-main-select">
        <div data-track-text="切换开票记录" @click="()=>activeName='fp'" :class="activeName==='fp'?'ischeck':''">开票记录</div>
        <div data-track-text="切换历史订单" @click="()=>activeName='dd'" :class="activeName==='dd'?'ischeck':''">历史订单</div>
      </div>
      <div v-show="activeName==='fp'">
        <div class="infinite-list-wrapper order-h5-list-wrapper"
             style="margin-top:15px;width: 768px;display: flex;flex-flow: column;align-items: center">
          <ul class="infinite-list" v-infinite-scroll="load" style="overflow:auto;height:900px;">
            <li v-for="(item,i) in tableH5DataBill" :key="i" class="infinite-list-item"
                infinite-scroll-disabled="disabled">
              <div class="order-h5-row" data-track-text="查看发票详情" :data-track-business-id="item.billCode" style="width: 768px;display: flex;cursor: pointer" @click="toPath('Billdetail',item)">
                <div class="order-h5-label"
                  style="margin-left: 34px;width:130px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
                  开票编号
                </div>
                <div class="order-h5-value"
                  style="width:400px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #333333;">
                  {{ item.billCode }}
                </div>
                <div class="order-h5-status"
                  style="width:150px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
                  {{
                    item.status === 1 ? '开票中' : item.status === 2 ?
                      '开票完成' : item.status === 3 ? '已下载' : '开票失败'
                  }}
                </div>
                <div class="order-h5-arrow" style="font-size: 24px;ont-family: Adobe Heiti Std;font-weight: normal;color: #333333;">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </li>
          </ul>
          <p v-if="loading" style="font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
            加载中...</p>
          <p v-if="noMore" style="font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
            没有更多了</p>
        </div>
      </div>
      <div v-if="activeName==='dd'">
        <div class="infinite-list-wrapper order-h5-list-wrapper"
             style="margin-top:15px;width: 768px;display: flex;flex-flow: column;align-items: center">
          <ul class="infinite-list" v-infinite-scroll="loadDD" style="overflow:auto;height:900px;">
            <li v-for="(item,i) in tableH5Data" :key="i" class="infinite-list-item"
                infinite-scroll-disabled="disabledDD">
              <div class="order-h5-row" data-track-text="查看订单详情" :data-track-business-id="item.batchId" style="width: 768px;display: flex;cursor: pointer" @click="toPath('DDdetail',item)">
                <div class="order-h5-label"
                  style="margin-left: 34px;width:130px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
                  订单编号
                </div>
                <div class="order-h5-value"
                  style="width:400px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #333333;">
                  {{ item.batchId }}
                </div>
                <div class="order-h5-status"
                  style="width:150px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
                  {{ item.status === undefined || item.status === null ? '未申请' : '已申请' }}
                </div>
                <div class="order-h5-arrow" style="font-size: 24px;ont-family: Adobe Heiti Std;font-weight: normal;color: #333333;">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </li>
          </ul>
          <p v-if="loadingDD" style="font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
            加载中...</p>
          <p v-if="noMoreDD" style="font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
            没有更多了</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {isSmallScreen, redirectToMainLogin} from '@/utils/responsive'

export default {
  name: "Order",
  data() {
    return {
      loadingDD: false,
      loading: false,
      activeName: 'fp',
      messages: '',
      isH5: false,
      isMockPreview: false,
      tableDataBill: [],
      tableH5DataBill: [],
      tableData: [],
      tableH5Data: [],
      multipleSelection: [],
      currentPageBill: 1,
      pageSizeBill: 5,
      currentPage: 1,
      pageSize: 8,
      total: 0,
      totalBill: 0,
      dialogFormVisible: false,
      form: {
        company: '',
        companyCode: '',
        content:'',
        batchId: []
      },
      formLabelWidth: '100px',
      updatePassFormRules: {
        company: [
          {required: true, message: '请输入单位名称', trigger: 'blur'},
          {min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur'}
        ],
        companyCode: [
          {required: true, message: '请输入单位税号', trigger: 'blur'},
          {min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请选择开票内容', trigger: 'change'},
        ]
      },
      totalMoney: 0
    }
  },
  watch: {
    "multipleSelection": function (value) {
      console.log(value)
      this.form.batchId = []
      this.totalMoney = 0
      value.forEach((val, index) => {

        this.form.batchId.push(val.batchId)
        this.totalMoney = this.add(this.totalMoney, val.turnover, 2)
      })
    }
  },
  beforeMount() {
    this.updateViewportMode()
  },
  created() {
    this.isMockPreview = this.shouldUseMockPreview()
    if (this.isMockPreview) {
      this.applyMockBills()
      this.applyMockOrders()
    } else {
      this.selectOrderBill()
      this.selectOrder()
      this.getCompany()
      this.loadDD()
    }
  },
  computed: {
    noMore() {
      return this.totalBill >= this.tableH5DataBill.length
    },
    disabled() {
      return this.loading || this.noMore
    },
    noMoreDD() {
      return this.total >= this.tableH5Data.length
    },
    disabledDD() {
      return this.loadingDD || this.noMoreDD
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateViewportMode)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewportMode)
  },
  methods: {
    shouldUseMockPreview() {
      return process.env.NODE_ENV === 'development' && this.$route && this.$route.query.mock === '1'
    },
    getMockBills() {
      return [
        {
          billCode: 'FP202607170001',
          productTitles: '专业文档翻译@#@英文论文润色',
          createDateTimeStr: '2026-07-17 09:36',
          turnover: '427.00',
          status: 1
        },
        {
          billCode: 'FP202607160018',
          productTitles: '多语种翻译服务',
          createDateTimeStr: '2026-07-16 15:20',
          turnover: '168.00',
          status: 2,
          filePath: ''
        }
      ]
    },
    getMockOrders() {
      return [
        {
          batchId: 'WS202607170026',
          productTitle: '专业文档翻译（中译英）',
          createDateTimeStr: '2026-07-17 10:18',
          turnover: '128.00',
          status: null
        },
        {
          batchId: 'WS202607160031',
          productTitle: '英文论文母语润色',
          createDateTimeStr: '2026-07-16 14:42',
          turnover: '299.00',
          status: 1
        },
        {
          batchId: 'WS202607150009',
          productTitle: 'AI 图片翻译',
          createDateTimeStr: '2026-07-15 11:06',
          turnover: '39.90',
          status: null
        }
      ]
    },
    applyMockOrders() {
      const mockOrders = this.getMockOrders()
      this.tableData = mockOrders
      this.tableH5Data = mockOrders.map(item => ({...item}))
      this.total = mockOrders.length
    },
    applyMockBills() {
      const mockBills = this.getMockBills()
      this.tableDataBill = mockBills
      this.tableH5DataBill = mockBills.map(item => ({...item}))
      this.totalBill = mockBills.length
    },
    displayValue(value) {
      return value === undefined || value === null || value === '' ? '--' : value
    },
    displayMoney(value) {
      return value === undefined || value === null || value === '' ? '0.00' : value
    },
    formatProductTitles(value) {
      return value ? value.split('@#@').join(' ') : '--'
    },
    billStatusText(status) {
      return status === 1 ? '开票中' : status === 2 ? '开票完成' : status === 3 ? '已下载' : '开票失败'
    },
    billStatusClass(status) {
      return status === 1 ? 'order-status--processing' :
        status === 2 ? 'order-status--done' :
          status === 3 ? 'order-status--downloaded' : 'order-status--failed'
    },
    isOrderSelected(row) {
      return this.multipleSelection.some(item => item.batchId === row.batchId)
    },
    toggleMobileOrder(row, checked) {
      if (!this.selectable(row)) {
        return
      }
      const nextSelection = this.multipleSelection.filter(item => item.batchId !== row.batchId)
      if (checked) {
        nextSelection.push(row)
      }
      this.multipleSelection = nextSelection
      this.$track('invoice_order_selection_change', {selectedCount: nextSelection.length, checked: Boolean(checked)})
    },
    loadDD() {
      this.loadingDD = true
      this.$http.get("/api/account/selectOrder?currentPage=" + this.currentPage + "&pageSize=" + this.pageSize).then(res => {
        if (res.data && res.data.orders.length > 0) {
          this.tableH5Data.push(...res.data.orders)
          this.total = res.data.total
          this.currentPage = this.currentPage + 1
        }
        this.loadingDD = false
      }).catch(err => {
        this.loadingDD = false
      })
    },
    load() {
      this.loading = true
      this.$http.get("/api/account/selectOrderBill?currentPage=" + this.currentPageBill + "&pageSize=" + this.pageSizeBill).then(res => {
        if (res.data && res.data.orderBills.length > 0) {
          this.tableH5DataBill.push(...res.data.orderBills)
          this.totalBill = res.data.total
          this.currentPageBill = this.currentPageBill + 1
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
      })
    },
    clickHanler(url) {
      document.location.href = "https://wesitrans.com/index"
    },
    toPath(name, item) {
      if (this.isMockPreview) {
        this.$track('order_detail_open_result', {target: name, result: 'preview_blocked'})
        this.$message.info("演示数据仅用于查看列表样式")
        return
      }
      this.$track('order_detail_open', {target: name})
      this.$router.push({
        name: name,
        params: item
      });
    },
    add(arg1, arg2, num) {//num为保留位数,不传时不四舍五入
      arg1 = Number(arg1);
      arg2 = Number(arg2);
      var r1 = 0, r2 = 0, m
      try {
        r1 = arg1.toString().split('.')[1].length;
      } catch (e) {
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
      }
      m = Math.pow(10, Math.max(r1, r2));
      if (num || num === 0) {
        return ((arg1 * m + arg2 * m) / m).toFixed(num) //注意：fixed四舍五入大于5会进1 5并不会进1
      }
      return (arg1 * m + arg2 * m) / m
    },
    getCompany() {
      this.$http.get("/api/account/getCompany").then(res => {
        if (res.data && res.data !== '') {
          this.form.company = res.data.company
          this.form.companyCode = res.data.company_code
        }
      }).catch(err => {
      })
    },
    submit() {
      if (this.isMockPreview) {
        this.$track('invoice_apply_result', {result: 'preview_blocked', selectedCount: this.form.batchId.length})
        this.dialogFormVisible = false
        this.$message.info("演示数据不会提交真实开票申请")
        return
      }
      this.$track('invoice_apply_submit', {selectedCount: this.form.batchId.length})
      this.$refs.updatePassForm.validate((valid) => {
        if (!valid) {
          this.$track('invoice_apply_result', {result: 'validation_failed', selectedCount: this.form.batchId.length})
          return;
        }
        this.$http.get("/api/account/applyBill?batchIds=" + this.form.batchId.join(',') +
          "&company=" + this.form.company + "&companyCode=" + this.form.companyCode +
          "&content=" + this.form.content).then(res => {

          if (res.data) {
            if (res.data === 'ok') {
              this.$track('invoice_apply_result', {result: 'success', selectedCount: this.form.batchId.length})
              this.$message.success("已提交申请，请稍后")
              this.dialogFormVisible = false
              this.selectOrder()
              this.selectOrderBill()
              return
            }
            if (res.data === 'need_login') {
              this.$track('invoice_apply_result', {result: 'failure', reason: 'need_login', selectedCount: this.form.batchId.length})
              this.$message.warning("登录失效，请重新登录")
              this.dialogFormVisible = false
              setTimeout(redirectToMainLogin, 3000)
              return;
            }
            this.$track('invoice_apply_result', {result: 'failure', reason: 'business_rejected', selectedCount: this.form.batchId.length})
            this.messages = res.data
          }
        }).catch(err => {
          this.$track('invoice_apply_result', {result: 'failure', reason: 'request_failed', selectedCount: this.form.batchId.length})
          this.$message.error("操作异常，请稍后再试")
        })
      })
    },
    handleOpen(index, row) {
      this.form.batchId = []
      this.form.batchId.push(row.batchId)
      this.dialogFormVisible = true
    },
    handleOpenAll() {
      this.dialogFormVisible = true
    },
    isMobile() {
      return isSmallScreen()
    },
    updateViewportMode() {
      this.isH5 = this.isMobile()
    },
    selectable(row, index) {
      return row.status === undefined || row.status === null;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$track('invoice_order_selection_change', {selectedCount: val.length})
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$track('order_history_page', {pageNumber: val, pageSize: this.pageSize})
      this.selectOrder()
    },
    download(row) {
      if (this.isMockPreview) {
        this.$track('invoice_download_result', {result: 'preview_blocked'})
        this.$message.info("演示数据不下载真实发票文件")
        return
      }
      console.log(row)
      if (!row.filePath) {
        this.$track('invoice_download_result', {result: 'failure', reason: 'missing_file'})
        this.$message.warning("下载失败，请联系客服")
        return
      }
      const filePaths = row.filePath.split("@#@")
      this.$track('invoice_download_submit', {fileCount: filePaths.length})
      filePaths.forEach((item, index) => {
        fetch(item).then(res => res.blob().then(blob => {
          let a = document.createElement('a');
          let url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = row.billCode + "-发票（微思翻译wesitrans.com）.pdf";

          a.click();
          window.URL.revokeObjectURL(url);
          this.$track('invoice_download_result', {result: 'success', fileCount: 1})
        })).catch(() => {
          this.$track('invoice_download_result', {result: 'failure', reason: 'request_failed', fileCount: 1})
        });
      })

    },
    handleCurrentChangeBill(val) {
      this.currentPageBill = val;
      this.$track('invoice_history_page', {pageNumber: val, pageSize: this.pageSizeBill})
      this.selectOrderBill()
    },
    selectOrder() {
      this.$http.get("/api/account/selectOrder?currentPage=" + this.currentPage + "&pageSize=" + this.pageSize).then(res => {
        if (res.data) {
          const orders = res.data.orders || []
          if (this.isMockPreview && orders.length === 0) {
            this.applyMockOrders()
          } else {
            this.tableData = orders
            this.total = res.data.total
          }
        }
      }).catch(err => {
        if (this.isMockPreview) {
          this.applyMockOrders()
        }
      })
    },
    selectOrderBill() {
      const that = this
      this.$http.get("/api/account/selectOrderBill?currentPage=" + this.currentPageBill + "&pageSize=" + this.pageSizeBill).then(res => {

        if (res.data) {
          const orderBills = res.data.orderBills || []
          if (this.isMockPreview && orderBills.length === 0) {
            this.applyMockBills()
          } else {
            this.tableDataBill = orderBills
            this.totalBill = res.data.total
          }
        }
      }).catch(err => {
        if (this.isMockPreview) {
          this.applyMockBills()
        }
      })
    }
  }
}
</script>
<style>
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #0c7dba !important;
  border-color: #0c7dba !important;
}
.custome-label-radio .el-form-item__content{
  margin-left: 100px;
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: space-evenly;
  height: 120px;
}
</style>
<style scoped>

.order-page,
.order-desktop,
.order-table-section,
.order-table-scroll {
  width: 100%;
  max-width: 100%;
}

.order-section-header,
.order-section-title {
  display: flex;
  align-items: center;
}

.order-section-title {
  min-width: 0;
  gap: 8px;
}

.order-mock-badge {
  display: inline-flex;
  height: 24px;
  padding: 0 8px;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border: 1px solid rgba(12, 125, 186, .24);
  border-radius: 999px;
  color: var(--wiseivy-accent, #0c7dba);
  background: #eef8fd;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

.order-h5-preview-note {
  display: flex;
  width: 100%;
  min-height: 44px;
  padding: 9px 14px;
  align-items: center;
  gap: 8px;
  color: #66717d;
  background: #f7fbfe;
  font-size: 12px;
}

.order-mobile-list {
  display: none;
}

.infinite-list {
  height: 900px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.infinite-list-item {
  margin-top: 15px;
  min-width: 768px;
  height: 80px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
}

.ischeck {
  border-bottom: 3px solid #063F95;
}

.user-main-select div:nth-child(1) {
  margin-left: 34px;
  margin-right: 63px;
  height: 80px;
  display: flex;
  align-items: center;
}

.user-main-select div:nth-child(2) {
  height: 80px;
  display: flex;
  align-items: center;
}

.user-main-select {
  width: 768px;
  height: 80px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}

.user-main {
  min-width: 765px;
  width: 100%;
  background: #f5f5f5;
  display: flex;
  flex-flow: column;
  align-items: center;
  overflow-x: hidden;
}

.user-main-head {
  width: 100%;
  height: 88px;
  background: #E6E6E6;
  display: flex;
  align-items: center;
}

.user-main-head div {
  flex: 1;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  text-align: center;
  margin-right: 60px;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #0c7dba;
  color: #FFF;
}

.no2-1 {
  cursor: pointer;
  padding: 5px 14px;
  width: 58px;
  height: 35px;
  background: #edf2fc;
  border: 1px solid #edf2fc;
  border-radius: 2px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #c0c4cc;
}

.no-1 {
  cursor: pointer;
  padding: 5px 14px;
  width: 58px;
  height: 35px;
  background: #0c7dba;
  border: 1px solid #0c7dba;
  border-radius: 2px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.no2 {
  cursor: pointer;
  padding: 5px 14px;
  width: 86px;
  height: 35px;
  background: #edf2fc;
  border: 1px solid #edf2fc;
  border-radius: 2px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #c0c4cc;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #0c7dba !important;
  border-color: #0c7dba !important;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #0c7dba;
  border-color: #0c7dba;
}

.no-he {
  cursor: pointer;
  padding: 5px 14px;
  width: 56px;
  height: 20px;
  background: #0c7dba;
  border: 1px solid #0c7dba;
  border-radius: 2px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin-right: 25px;
}

.no {
  cursor: pointer;
  padding: 5px 14px;
  width: 86px;
  height: 35px;
  background: #0c7dba;
  border: 1px solid #0c7dba;
  border-radius: 2px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.submitUpadatePass:hover {
  padding: 10px 45px;
  background: #0c7dba !important;
  border-radius: 2px;
  font-size: 14px;
  font-family: "Adobe Heiti Std";
  font-weight: normal;
  color: rgb(255, 255, 255);
  cursor: pointer;
}

.submitUpadatePass {
  padding: 10px 45px;
  background: #063f95;
  border-radius: 2px;
  font-size: 14px;
  font-family: "Adobe Heiti Std";
  font-weight: normal;
  color: rgb(255, 255, 255);
}

.custome-input {
  width: 368px;
  height: 40px;
  border: 0px solid #DDDDDD;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  float: left;
}

.custome-label.el-form-item {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

#recharge-div-one {
  background: #FFFFFF;
  overflow: hidden;
  margin-bottom: 20px;
}

#recharge-div {
  background: #FFFFFF;
  overflow: hidden;
  height: 870px;
  text-align: left;
}

@media (max-width: 768px) {
  .order-page,
  .order-desktop {
    width: 100%;
    max-width: 100%;
  }

  #recharge-div-one,
  #recharge-div {
    width: 100%;
    height: auto;
    min-height: 0;
    padding: 14px 12px 24px;
    overflow: visible;
  }

  #recharge-div-one {
    margin-bottom: 12px;
  }

  .order-section-header {
    width: 100% !important;
    height: auto !important;
    min-height: 48px;
    padding: 0 4px;
  }

  .order-section-header .title-font {
    width: auto;
    height: auto;
    margin: 0 !important;
    display: flex;
    align-items: center;
    font-size: 17px !important;
  }

  .order-history-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .order-selection-summary {
    width: 100%;
    min-width: 0;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 8px;
    padding-bottom: 8px;
  }

  .order-selection-summary .no-he {
    width: auto;
    height: 34px;
    margin-right: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }

  .order-table-scroll {
    display: none;
  }

  .order-mobile-list {
    display: grid;
    width: 100%;
    gap: 12px;
  }

  .order-card {
    position: relative;
    width: 100%;
    overflow: hidden;
    border: 1px solid #dbe6ef;
    border-left: 3px solid var(--wiseivy-accent, #0c7dba);
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 5px 18px rgba(31, 72, 111, .07);
  }

  .order-card__header {
    display: flex;
    min-width: 0;
    padding: 13px 14px 12px;
    align-items: flex-start;
    gap: 10px;
    border-bottom: 1px solid #edf2f6;
  }

  .order-card__selection {
    display: flex;
    min-height: 38px;
    align-items: center;
  }

  .order-card__identity {
    display: flex;
    min-width: 0;
    flex: 1 1 auto;
    flex-direction: column;
    gap: 4px;
  }

  .order-card__eyebrow,
  .order-card__field > span {
    color: #7a8793;
    font-size: 11px;
    line-height: 1.35;
  }

  .order-card__number {
    overflow-wrap: anywhere;
    color: #263341;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.45;
  }

  .order-status {
    display: inline-flex;
    min-height: 24px;
    padding: 4px 9px;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
  }

  .order-status--processing,
  .order-status--pending {
    color: #9a6200;
    background: #fff4d8;
  }

  .order-status--done,
  .order-status--downloaded {
    color: #087752;
    background: #e9f8f1;
  }

  .order-status--failed {
    color: #bd3838;
    background: #fff0f0;
  }

  .order-card__content {
    display: grid;
    padding: 13px 14px;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 12px 14px;
  }

  .order-card__field {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 4px;
  }

  .order-card__field--full {
    grid-column: 1 / -1;
  }

  .order-card__field--amount {
    align-items: flex-end;
    text-align: right;
  }

  .order-card__field > strong {
    overflow-wrap: anywhere;
    color: #344150;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.55;
  }

  .order-card__field--amount > strong {
    color: var(--wiseivy-primary, #063f95);
    font-size: 15px;
    font-weight: 700;
  }

  .order-card__actions {
    display: flex;
    padding: 0 14px 13px;
    justify-content: flex-end;
    gap: 8px;
  }

  .order-card__button {
    min-width: 84px;
    height: 34px;
    padding: 0 14px;
    border-radius: 6px;
    font: inherit;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
  }

  .order-card__button--ghost {
    color: var(--wiseivy-primary, #063f95);
    border: 1px solid #b8cce0;
    background: #fff;
  }

  .order-card__button--primary {
    color: #fff;
    border: 1px solid var(--wiseivy-primary, #063f95);
    background: linear-gradient(90deg, var(--wiseivy-primary, #063f95), var(--wiseivy-accent, #0c7dba));
    box-shadow: 0 4px 10px rgba(6, 63, 149, .16);
  }

  .order-card__button:disabled {
    color: #aab4bf;
    border-color: #e5eaf0;
    background: #f2f5f8;
    box-shadow: none;
    cursor: not-allowed;
  }

  .order-empty-state {
    display: flex;
    width: 100%;
    min-height: 142px;
    padding: 20px 16px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 8px;
    border: 1px dashed #c8d7e5;
    border-radius: 10px;
    color: #8a98a5;
    background: #f8fbfd;
    text-align: center;
  }

  .order-empty-state > i {
    color: var(--wiseivy-accent, #0c7dba);
    font-size: 30px;
  }

  .order-empty-state > strong {
    color: #344150;
    font-size: 14px;
    font-weight: 600;
  }

  .order-empty-state > span {
    width: 100%;
    max-width: 280px;
    font-size: 12px;
    line-height: 1.55;
    overflow-wrap: anywhere;
    word-break: break-all;
  }

  .order-pagination {
    width: 100%;
    overflow-x: auto;
    justify-content: flex-start !important;
    padding-bottom: 4px;
    -webkit-overflow-scrolling: touch;
  }

  .order-pagination /deep/ .el-pagination {
    width: max-content;
    min-width: 100%;
    white-space: nowrap;
  }

  .order-page /deep/ .el-alert {
    margin: 0 12px 12px;
    width: calc(100% - 24px);
    padding: 10px 12px;
    align-items: flex-start;
    border-radius: 8px;
  }

  .order-page /deep/ .el-alert__content {
    min-width: 0;
  }

  .order-page /deep/ .el-alert__title {
    line-height: 1.55;
    white-space: normal;
  }

  .order-page /deep/ .el-dialog {
    width: calc(100% - 24px) !important;
    max-width: 546px;
    margin-top: 8vh !important;
  }

  .order-page /deep/ .el-dialog__body,
  .order-page /deep/ .el-dialog__footer {
    padding-right: 16px;
    padding-left: 16px;
  }

  .order-page /deep/ .custome-input {
    width: 100%;
    float: none;
  }

  .user-main {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    align-items: stretch;
    overflow-x: hidden;
  }

  .user-main-select {
    width: 100%;
    height: 56px;
    font-size: 15px;
  }

  .user-main-select div:nth-child(1),
  .user-main-select div:nth-child(2) {
    height: 56px;
    margin: 0 !important;
    flex: 1 1 0;
    justify-content: center;
  }

  .order-h5-list-wrapper {
    width: 100% !important;
    max-width: 100%;
    margin-top: 0 !important;
    padding: 0 12px 16px;
  }

  .infinite-list {
    width: 100%;
    height: calc(100vh - 182px) !important;
    height: calc(100dvh - 182px) !important;
    min-height: 420px;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
  }

  .infinite-list-item {
    width: 100%;
    min-width: 0;
    height: auto;
    min-height: 70px;
    margin-top: 10px;
    border: 1px solid #e1eaf2;
    border-radius: 10px;
    box-shadow: 0 3px 12px rgba(40, 74, 108, .06);
  }

  .order-h5-row {
    width: 100% !important;
    min-width: 0;
    padding: 12px;
    display: grid !important;
    grid-template-columns: 68px minmax(0, 1fr) auto 18px;
    align-items: center;
    gap: 8px;
  }

  .order-h5-label,
  .order-h5-value,
  .order-h5-status,
  .order-h5-arrow {
    width: auto !important;
    min-width: 0;
    margin: 0 !important;
    font-size: 13px !important;
    line-height: 1.45;
  }

  .order-h5-label,
  .order-h5-status {
    color: #66717d !important;
  }

  .order-h5-value {
    overflow: hidden;
    color: #263341 !important;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .order-h5-status {
    white-space: nowrap;
  }

  .order-h5-arrow {
    font-size: 16px !important;
  }

  .order-h5-list-wrapper > p {
    margin: 12px 0;
    font-size: 13px !important;
  }
}
</style>
